import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SearchSettings } from '@bazis/shared/models/srv.types';
import { BazisAutocompleteComponent } from '@bazis/form/components/base/autocomplete/autocomplete.component';


// Всплывашка вниз, по кнопке, внутри строка с поиском по списку с настройками searchSettings
@Component({
    selector: 'bazis-dropdown-search',
    templateUrl: './dropdown-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisDropdownSearchComponent extends BazisAutocompleteComponent {
    @Input() searchSettings: SearchSettings = null;

    @Input()
    emptySelectedKey: string = null;

    multiple = false;
}
